import styles from '../../UserHistory.module.less';
import HistoryItem from '../HistoryItem';

const HistoryList = ({ items }) => {
  let previousMonth = null;

  const renderItems = items.map((item) => {
    const currentMonth = new Date(item.date).toLocaleString('default', {
      month: 'long',
    });

    // Verifica se o mês mudou
    const showMonth = currentMonth !== previousMonth;
    previousMonth = currentMonth;

    return (
      <HistoryItem
        key={item.id}
        item={item}
        month={showMonth ? currentMonth : false}
      />
    );
  });

  return (
    <div className={styles.list}>
      <ol>{renderItems}</ol>
    </div>
  );
};

export default HistoryList;
